import { z } from 'zod';
import type { BrandingInput } from './api.js';

/** Sunucudaki sınırla aynı (`packages/db` `BRAND_LOGO_MAX_BYTES`; ADR 0019 §4). */
export const LOGO_MAX_BYTES = 64 * 1024;
export const LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'] as const;

/** Ofiste rozet iki satır slogandır ("Safe Crew · Safe Voyage"); gemide üst satır gemi adı. */
export function sloganLines(slogan: string): { title: string; subtitle: string } {
  const [title = '', ...rest] = slogan.split(/\s*[·|]\s*/);
  return { title, subtitle: rest.join(' · ') };
}

const optional = (max: number) => z.string().trim().max(max, 'settings.branding.tooLong');

/** Marka formu: sunucudaki şemayla aynı sınırlar (`apps/server/src/office/branding.ts`). */
export const brandingSchema = z.object({
  name: optional(60),
  tagline: optional(80),
  vesselSlogan: optional(60),
});

export type BrandingValues = z.infer<typeof brandingSchema>;

const orNull = (value: string) => (value === '' ? null : value);

export function toInput(
  values: BrandingValues,
  logo: string | null,
  rowVersion: number | undefined,
): BrandingInput {
  return {
    ...(rowVersion === undefined ? {} : { rowVersion }),
    name: orNull(values.name),
    tagline: orNull(values.tagline),
    logo,
    vesselSlogan: orNull(values.vesselSlogan),
  };
}

/** Seçilen logo dosyasının sorunu (çeviri anahtarı) ya da `null`. */
export function logoProblem(file: { type: string; size: number }): string | null {
  if (!(LOGO_TYPES as readonly string[]).includes(file.type)) return 'settings.branding.logoType';
  if (file.size > LOGO_MAX_BYTES) return 'settings.branding.logoSize';
  return null;
}

/** Dosyayı veri adresine çevirir (`data:image/...;base64,...`). */
export function readAsDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
